import { API } from "aws-amplify";
import { useQuery } from "react-query";
import { IOrganization } from "../../../../models/Organization";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (): Promise<IOrganization[]> => {
  const qParams = {};

  return API.get(APIEndpoints.private, "/api/v1/organizations/", qParams);
};

export const useListOrganizations = () => {
  return useQuery<IOrganization[]>(
    QueryKeys.organizations(),
    () => makeApiRequest(),
    {
      retry: 1,
    }
  );
};
